import cookies from 'js-cookie';
import React, { useEffect } from 'react';
import { Redirect } from 'react-router';
import { AUTH_COOKIE, AUTH_REFRESH_COOKIE } from 'store/store';

export const Logout = ({ onClearToken }: { onClearToken: () => void }) => {
  useEffect(() => {
    cookies.remove(AUTH_COOKIE);
    cookies.remove(AUTH_REFRESH_COOKIE);
    onClearToken();
  }, [onClearToken]);

  return <Redirect to="/login" />;
};
